import { Button } from '@seen/ui'
import type { JSX } from 'react'
import { Dialog } from '#src/components/core/dialog/Dialog.tsx'
import { DialogContent } from '#src/components/core/dialog/DialogContent.tsx'
import { DialogDescription } from '#src/components/core/dialog/DialogDescription.tsx'
import { DialogFooter } from '#src/components/core/dialog/DialogFooter.tsx'
import { DialogHeader } from '#src/components/core/dialog/DialogHeader.tsx'
import { DialogTitle } from '#src/components/core/dialog/DialogTitle.tsx'
import { DialogDisplay } from '#src/components/core/dialog/display/DialogDisplay.tsx'
import { useDeleteConfirmationStore } from '#src/hooks/useDeleteConfirmationStore.ts'

export function DeleteConfirmationDialog(): JSX.Element {
  // Note we have DeleteConfirmationDialog at the app level. This is because certain actions (i.e. deleting from a context menu) wouldn't work with a local confirmation dialog since the context menu gets unmounted when the action is triggered.

  const isOpen = useDeleteConfirmationStore((state) => state.isOpen)
  const title = useDeleteConfirmationStore((state) => state.title)
  const description = useDeleteConfirmationStore((state) => state.description)
  const deleteText = useDeleteConfirmationStore((state) => state.deleteText)
  const onConfirm = useDeleteConfirmationStore((state) => state.onConfirm)
  const setIsOpen = useDeleteConfirmationStore((state) => state.setIsOpen)

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogDisplay>
        <DialogHeader asChild>
          <DialogTitle>
            <p>{title}</p>
          </DialogTitle>
        </DialogHeader>
        <DialogContent className="py-0">
          <DialogDescription>{description}</DialogDescription>
        </DialogContent>
        <DialogFooter className="mt-2">
          <Button variant="outline" onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={() => {
              onConfirm()
              setIsOpen(false)
            }}
          >
            {deleteText}
          </Button>
        </DialogFooter>
      </DialogDisplay>
    </Dialog>
  )
}
